<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div style="margin-top: -7rem !important;">
    <div class="page-header-card mb-3 nav-redish-gradient-bg">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-4 mt-5">
            <div class="vx-col w-full text-center">
              <custom-svg variant="menu" width="60" height="60" color="white" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">menu</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <coming-soon></coming-soon>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import ComingSoon from '@/gen-2/components/ComingSoon.vue';
export default {
  components: {
    CustomSvg,
    ComingSoon
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  methods: {
    
  },
  mounted() {
    
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>